import { Localization, SessionContext, SettingsManager } from "@viamap/viamap2-common";
import { useContext, useEffect, useState } from "react";
import { GlassButton } from "src/components/GlassButtons";
import { ADModalBody, ADModalFooter, ADModalInfo } from "src/componentsUtils/AdvancedDragModal";
import { JobActionType, JobsContext, JobType, JobTypeUserAccessRights, getMyAccessRights } from "./JobState";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";
import { GlassInputControl, GlassInputGroup, GlassTextInputTransformer } from "src/components/GlassInput";
import { JobServiceInterface } from "./JobServiceInterface";
import { JsonViewer } from "./JsonViewer";
import { JobModuleJobInputs } from "./JobModuleJobInputs";
import { message } from "src/components/Message";
import { MapitStateContext } from "src/states/MapitState";
import { GlassFoldUdBox } from "src/propertyInfoTemplates/PropertyComponents";
import { JobModuleIntervalInputs } from "./JobModuleIntervalInputs";


export function JobInputParamsServer(_props: {
   selectedJobType: JobType;
   onCallback: (id) => void;
}) {
   const { state: jobsState, dispatch: jobsDispatch } = useContext(JobsContext);
   const { hasAccessToFeature } = useContext(ApplicationStateContext);
   const { state: sessionState } = useContext(SessionContext);
   const { state: mapitState } = useContext(MapitStateContext);
   const [jobSetttings, setJobSettings] = useState<any>(null);
   const [jobIntervalSettings, setJobIntervalSettings] = useState<any>(null);
   const [jobName, setJobName] = useState<string>("");
   const [jobInterface] = useState<JobServiceInterface>(new JobServiceInterface({
      userRef: sessionState.userRef,
      userName: sessionState.userName,
      organizationId: sessionState.customerRef,
      languageCode: Localization.getLanguage() as "da" | "en"
   }));

   const [serverInfo, setSI] = useState<any>({});

   useEffect(() => {
      if (jobsState.selectedJobType?.serverTypeName) {
         if (serverInfo[jobsState.selectedJobType?.serverTypeName]) {
            return
         } else {
            let x = jobsState.selectedJobType?.serverTypeName;
            jobInterface.JobListing(jobsState.selectedJobType?.serverTypeName).then((res: any) => {
               setSI((prevState) => {
                  return {
                     ...prevState,
                     [x]: res
                  }
               })
            });
         }
      }
   }, [jobsState.selectedJobType?.serverTypeName]);

   function filterProjectsByAccessRights(project: JobType): boolean {
      if (hasAccessToFeature(Feature.JobModuleGlobalAdmin)) {
         return true;
      };
      let accessRights = getMyAccessRights(project as any, sessionState.userRef, sessionState.customerRef);
      if (accessRights && accessRights.includes(JobTypeUserAccessRights.Write)) {
         return true;
      }
      return false;
   }

   async function handleJobStart() {
      let serverName = jobsState.selectedJobType?.serverTypeName || "";
      let inputParams = serverInfo[serverName]?.inputParams;

      if (inputParams === undefined && typeof serverName !== "string") {
         message.error(Localization.getText("Ingen input parametre"));
         return;
      }
      jobInterface.CreateJob(serverName, jobName).then(async (res) => {
         let resSettings = { ...jobSetttings }
         let resIntervalSettings = { ...jobIntervalSettings }
         let jobId = res.jobId;
         for (let key in inputParams) {
            if (inputParams[key].type == "layer") {
               resSettings[key] = mapitState.layers[jobSetttings[key]].datasetname + ".geojson";
               await jobInterface.JobUploadJson(jobId, mapitState.layers[jobSetttings[key]].datasetname + ".geojson", JSON.stringify(mapitState.layers[jobSetttings[key]].geoJson))
            }
            if (inputParams[key].type == "file") {
               if (jobSetttings[key] === undefined) {
                  if (inputParams[key]?.required) {
                     message.error(Localization.getText("File is required") + " " + key);
                     return;
                  } else {
                     continue;
                  }
               }
               await jobInterface.JobUpload(jobId, jobSetttings[key].file);
               delete resSettings[key].file;
               resSettings[key] = jobSetttings[key];
            }
            if (inputParams[key].type == "systemSetting") {
               resSettings[key] = SettingsManager.getSystemSetting(inputParams[key].setting);
               if (resSettings[key] === undefined) {
                  message.error(Localization.getText("System setting not found") + " " + inputParams[key].setting);
                  return;
               }
            }
         }
         // Combine regular settings and interval settings into one payload
         let combinedSettings = {
            ...resSettings,
            intervalSettings: resIntervalSettings
         }
         await jobInterface.JobUploadSettings(jobId, JSON.stringify(combinedSettings))
         await jobInterface.StartJob(jobId);
         console.log(combinedSettings);
         message.info(Localization.getFormattedText("Job started: {name}", { name: jobName }));
      })
   }

   const SelectProject = (props: { title: string, onSelect: (value: string) => void }) => {
      return (
         <>
            <div className="GlassInputControl" >
               <select onChange={e => {
                  let id = e.target.value;
                  props.onSelect(id);
               }}
                  style={{ width: "auto" }}
                  value={jobsState.selectedJobTypeId}
                  required
               >
                  {jobsState.selectedJobTypeId ? <></> : <option key={"default"} value={""} >{Localization.getText("Vælg jobtype")}</option>}
                  {(jobsState.availableJobTypesList || []).filter(filterProjectsByAccessRights).toSorted((a, b) => (a.name || "").localeCompare(b.name || "")).map((p: JobType, idx: number) => {
                     return (
                        <option key={p.id + idx} value={p.id}>{p.name}</option>
                     );
                  })}
               </select>
            </div>
         </>
      )
   }



   return (
      <>
         <ADModalInfo center={true} >
            {serverInfo[jobsState.selectedJobType?.serverTypeName || ""] ? <div>{serverInfo[jobsState.selectedJobType?.serverTypeName || ""]?.da?.name}</div> : <></>}
            {serverInfo[jobsState.selectedJobType?.serverTypeName || ""] ? <div style={{ fontSize: "13px" }}>{serverInfo[jobsState.selectedJobType?.serverTypeName || ""]?.da?.description}</div> : <></>}
         </ADModalInfo>
         <ADModalBody >

            <GlassInputGroup>
               {/* <GlassInputGroupTitle></GlassInputGroupTitle> */}
               <GlassTextInputTransformer label={Localization.getText("Vælg jobtype")} >
                  <SelectProject title={Localization.getText("Vælg jobtype")} onSelect={(id) => {
                     jobsDispatch({
                        type: JobActionType.SelectJobType,
                        payload: { id }
                     });
                     // let p = jobsState.availableJobTypesList?.filter(filterProjectsByAccessRights).find((a) => a.id === id);
                  }}
                  />
               </GlassTextInputTransformer>
               <GlassTextInputTransformer label={Localization.getText("Name")} >
                  <GlassInputControl>
                     <input type="text" required value={jobName || ""} onChange={(e) => setJobName(e.target.value)} />
                  </GlassInputControl>
               </GlassTextInputTransformer>

               <JobModuleJobInputs jobInputParams={serverInfo[jobsState.selectedJobType?.serverTypeName || ""]?.inputParams} onChange={((e) => setJobSettings(e))} />
               <JobModuleIntervalInputs jobIntervalParams={serverInfo[jobsState.selectedJobType?.serverTypeName || ""]?.intervalParams} onChange={((e) => setJobIntervalSettings(e))} />

            </GlassInputGroup>
            {
               SettingsManager.getSystemSetting("debuggingShowExtraDebugging", false, true) ?
                  <GlassFoldUdBox variant="Small" title={"Debug"} foldetUd={false} >
                     <JsonViewer parsedJson={serverInfo[jobsState.selectedJobType?.serverTypeName || ""]} level={0} />
                  </GlassFoldUdBox> : <></>
            }
         </ADModalBody>
         <ADModalFooter>
            <GlassButton onClick={() => handleJobStart()} >
               {Localization.getText("Create job")}
            </GlassButton>

         </ADModalFooter>
      </>
   )
}


